export const IDAM_AUTH_LOCAL_STORAGE_FEATURE_KEY = 'metrox';
export const FLYOUT_FAILOVER_LOCAL_STORAGE_FEATURE_KEY = 'flyout_failover';
export const METRO_CARD_LOCAL_STORAGE_FEATURE_KEY = 'metro_card';
export const CART_UPDATE_LOCAL_STORAGE_FEATURE_KEY = 'cart_update';
export const SEARCH_VERSION_LOCAL_STORAGE_KEY = 'search_version';
export const SF_HP_SELLER_BANNER = 'seller_banner';
export const BLACK_DEALS_LOCAL_STORAGE_KEY = 'black_deals';
export const LOCAL_STORAGE_FEATURE_ENABLED_VALUE = 'on';
export const CHRISTMAS_NAVIGATION_MENU_LOCAL_STORAGE_KEY = 'christmas_navigation';
export const FILTER_CATEGORY_LIST_LOCAL_STORAGE_KEY = 'filter_category_list';
export const FREE_SHIPPING_THRESHOLD_IN_PDP = 'free_shipping_threshold_in_pdp';
export const FLIXMEDIA_DYSON_INTEGRATION = 'flixmedia_dyson_content';
export const SHIPPING_COMMUNICATION_LOCAL_STORAGE_KEY = 'new_shipping_communication';
export const OTHER_OFFERS_V2_LOCAL_STORAGE_KEY = 'other_offers_v2';
export const BLACK_DEALS_PDP_BANNER = 'black_deals_pdp_banner';
export const BLACK_DEALS_LIMITED_STOCK = 'black_deals_limited_stock';
export const BLACK_DEALS_NAVIGATION = 'black_deals_navigation';
